module.exports = __webpack_public_path__ + "static/media/21ECLAC32.554eb048.jpg";